import Head from 'next/head';
import Link from 'next/link';

export default function Privacy() {
    return <div className="p-3 max-w-1300px m-auto">
        <Head>
            <title>Terms of Service - CornHub</title>
        </Head>

        <h1 className="text-3xl font-bold">CornHub Terms of Service</h1>
        <h2 className="text-xl">Last updated 04 Jan, 2023</h2> {/* Also update revision number in constants */}

        <h2 className="text-lg">1. Terms</h2>

        <p>By accessing this Website, accessible via https://cornhub.website, you are agreeing to be bound by these
            Website Terms and Conditions of Use and agree that you are responsible for the agreement with any applicable
            local laws. If you disagree with any of these terms, you are prohibited from accessing this site. The
            materials contained in this Website are protected by copyright and trade mark law.</p>

        <h2 className="text-lg">2. Disclaimer</h2>

        <p>All the materials on CornHub's Website are provided "as is". CornHub makes no warranties, may it be expressed
            or implied, therefore negates all other warranties. Furthermore, CornHub does not make any representations
            concerning the accuracy or reliability of the use of the materials on its Website or otherwise relating to
            such materials or any sites linked to this Website.</p>

        <h2 className="text-lg">3. Limitations</h2>

        <p>CornHub or its suppliers will not be hold accountable for any damages that will arise with the use or
            inability to use the materials on CornHub's Website, even if CornHub or an authorize representative of this
            Website has been notified, orally or written, of the possibility of such damage. Some jurisdiction does not
            allow limitations on implied warranties or limitations of liability for incidental damages, these
            limitations may not apply to you.</p>

        <p>CornHub may partially or completely restrict your access to our service or your account for any reason at any
            time, if we deem you in violation of our policies.</p>

        <h2 className="text-lg">4. Revisions and Errata</h2>

        <p>The materials appearing on CornHub's Website may include technical, typographical, or photographic errors.
            CornHub will not promise that any of the materials in this Website are accurate, complete, or current.
            CornHub may change the materials contained on its Website at any time without notice. CornHub does not make
            any commitment to update the materials.</p>

        <h2 className="text-lg">5. Links</h2>

        <p>CornHub has not reviewed all of the sites linked to its Website and is not responsible for the contents of
            any such linked site. The presence of any link does not imply endorsement by CornHub of the site. The use of
            any linked website is at the user's own risk.</p>

        <h2 className="text-lg">6. Site Terms of Use Modifications</h2>

        <p>CornHub may revise these Terms of Use for its Website at any time without prior notice. CornHub will notify
            you if these terms were changed since the last time you visited, if you are logged in. By using this
            Website, you are agreeing to be bound by the current version of these Terms and Conditions of Use.</p>

        <h2 className="text-lg">7. Your Privacy</h2>

        <p>Please read our <Link className="text-primary underline" href="/legal/privacy">Privacy Policy</Link>.</p>

        <h2 className="text-lg">8. User Content</h2>

        <p>When submitting any user content to CornHub (this includes videos and comments) you represent and warrant
            that you own all rights to the User Content and you have paid for or otherwise have permission to use any
            User Content submitted. Furthermore, you represent and warrant that all user content is legal and that the
            content does not interfere with any third party rights or obligations.</p>

        <p>When you submit any user content to us, you grant CornHub a non-exclusive, unlimited, fully-paid,
            royalty-free, irrevocable, world-wide, universal, transferable, assignable license to display, distribute,
            store, broadcast, transmit, reproduce, modify, prepare derivative works, or use and reuse all or part of
            your user Content for the purposes of providing any services associated with the platform.</p>

        <h2 className="text-lg">9. Governing Law</h2>

        <p>Any claim related to CornHub's Website shall be governed by the laws of The Netherlands without regards to
            its conflict of
            law provisions.</p>
    </div>;
}
